var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66671 0.666626H2.00004C1.08337 0.666626 0.333374 1.41663 0.333374 2.33329V15.6666C0.333374 16.5833 1.08337 17.3333 2.00004 17.3333H12C12.9167 17.3333 13.6667 16.5833 13.6667 15.6666V5.66663L8.66671 0.666626ZM7.00004 7.33329C7.91671 7.33329 8.66671 8.08329 8.66671 8.99996C8.66671 9.91663 7.91671 10.6666 7.00004 10.6666C6.08337 10.6666 5.33337 9.91663 5.33337 8.99996C5.33337 8.08329 6.08337 7.33329 7.00004 7.33329ZM10.3334 14H3.66671V13.525C3.66671 12.85 4.06671 12.25 4.68337 11.9833C5.39171 11.675 6.17504 11.5 7.00004 11.5C7.82504 11.5 8.60837 11.675 9.31671 11.9833C9.93337 12.25 10.3334 12.85 10.3334 13.525V14Z",
    fill: "#434455"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.21f0f9072c9e8b5980bb8d9b06da3638.svg";
export { ForwardRef as ReactComponent };